!function (t, e) {
  "object" == typeof exports && "undefined" != typeof module ? module.exports = e(require("react"), require("prop-types")) : "function" == typeof define && define.amd ? define(["react", "prop-types"], e) : (t = "undefined" != typeof globalThis ? globalThis : t || self)["react-wavify"] = e(t.React, t.PropTypes);
}(this, function (t, e) {
  "use strict";

  function n(t) {
    return t && "object" == typeof t && "default" in t ? t : {
      default: t
    };
  }

  var s = n(t),
      r = n(e);

  function o(t, e) {
    for (var n = 0; n < e.length; n++) {
      var r = e[n];
      r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
    }
  }

  function i(t, e, n) {
    return e in t ? Object.defineProperty(t, e, {
      value: n,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : t[e] = n, t;
  }

  function c() {
    return (c = Object.assign || function (t) {
      for (var e = 1; e < arguments.length; e++) {
        var n = arguments[e];

        for (var r in n) {
          Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
        }
      }

      return t;
    }).apply(this, arguments);
  }

  function a(e, t) {
    var n = Object.keys(e);

    if (Object.getOwnPropertySymbols) {
      var r = Object.getOwnPropertySymbols(e);
      t && (r = r.filter(function (t) {
        return Object.getOwnPropertyDescriptor(e, t).enumerable;
      })), n.push.apply(n, r);
    }

    return n;
  }

  function u(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = null != arguments[t] ? arguments[t] : {};
      t % 2 ? a(Object(n), !0).forEach(function (t) {
        i(e, t, n[t]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : a(Object(n)).forEach(function (t) {
        Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
      });
    }

    return e;
  }

  function p(t) {
    return (p = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
      return t.__proto__ || Object.getPrototypeOf(t);
    })(t);
  }

  function f(t, e) {
    return (f = Object.setPrototypeOf || function (t, e) {
      return t.__proto__ = e, t;
    })(t, e);
  }

  function l(t, e) {
    if (null == t) return {};

    var n,
        r,
        o = function (t, e) {
      if (null == t) return {};
      var n,
          r,
          o = {},
          i = Object.keys(t);

      for (r = 0; r < i.length; r++) {
        n = i[r], 0 <= e.indexOf(n) || (o[n] = t[n]);
      }

      return o;
    }(t, e);

    if (Object.getOwnPropertySymbols) {
      var i = Object.getOwnPropertySymbols(t);

      for (r = 0; r < i.length; r++) {
        n = i[r], 0 <= e.indexOf(n) || Object.prototype.propertyIsEnumerable.call(t, n) && (o[n] = t[n]);
      }
    }

    return o;
  }

  function h(t) {
    if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return t;
  }

  function d(r) {
    var o = function () {
      if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
      if (Reflect.construct.sham) return !1;
      if ("function" == typeof Proxy) return !0;

      try {
        return Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), !0;
      } catch (t) {
        return !1;
      }
    }();

    return function () {
      var t,
          e = p(r);

      if (o) {
        var n = p(this).constructor;
        t = Reflect.construct(e, arguments, n);
      } else t = e.apply(this, arguments);

      return function (t, e) {
        return !e || "object" != typeof e && "function" != typeof e ? h(t) : e;
      }(this, t);
    };
  }

  var y = function () {
    !function (t, e) {
      if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
      t.prototype = Object.create(e && e.prototype, {
        constructor: {
          value: t,
          writable: !0,
          configurable: !0
        }
      }), e && f(t, e);
    }(r, t.Component);
    var n = d(r);

    function r(t) {
      var e;
      return function (t, e) {
        if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
      }(this, r), i(h(e = n.call(this, t)), "width", function () {
        return e.container.current.offsetWidth;
      }), i(h(e), "height", function () {
        return e.container.current.offsetHeight;
      }), e.container = s.default.createRef(), e.state = {
        path: ""
      }, e.defaults = {
        height: 20,
        amplitude: 20,
        speed: .15,
        points: 3
      }, e.options = u(u({}, t.options), e.defaults), e.lastUpdate = 0, e.elapsed = 0, e.step = 0, e.update = e.update.bind(h(e)), e;
    }

    return function (t, e, n) {
      e && o(t.prototype, e), n && o(t, n);
    }(r, [{
      key: "calculateWavePoints",
      value: function value() {
        for (var t = [], e = 0; e <= Math.max(this.options.points, 1); e++) {
          var n = e / this.options.points * this.width(),
              r = (this.step + (e + e % this.options.points)) * this.options.speed * 100,
              o = Math.sin(r / 100) * this.options.amplitude,
              i = Math.sin(r / 100) * o + this.options.height;
          t.push({
            x: n,
            y: i
          });
        }

        return t;
      }
    }, {
      key: "buildPath",
      value: function value(t) {
        function e(t, e) {
          return " C ".concat(t.x, " ").concat(t.y, " ").concat(t.x, " ").concat(t.y, " ").concat(e.x, " ").concat(e.y);
        }

        var n = "M ".concat(t[0].x, " ").concat(t[0].y),
            r = {
          x: (t[1].x - t[0].x) / 2,
          y: t[1].y - t[0].y + t[0].y + (t[1].y - t[0].y)
        };
        n += e(r, t[1]);

        for (var o = r, i = 1; i < t.length - 1; i++) {
          n += e(o = {
            x: t[i].x - o.x + t[i].x,
            y: t[i].y - o.y + t[i].y
          }, t[i + 1]);
        }

        return n += " L ".concat(this.width(), " ").concat(this.height()), n += " L 0 ".concat(this.height(), " Z");
      }
    }, {
      key: "redraw",
      value: function value() {
        this.setState({
          path: this.buildPath(this.calculateWavePoints())
        });
      }
    }, {
      key: "draw",
      value: function value() {
        if (!this.props.paused) {
          var t = new Date();
          this.elapsed += t - this.lastUpdate, this.lastUpdate = t;
        }

        this.step = this.elapsed * Math.PI / 1e3, this.redraw();
      }
    }, {
      key: "update",
      value: function value() {
        this.draw(), this.frameId && this.resume();
      }
    }, {
      key: "resume",
      value: function value() {
        this.frameId = window.requestAnimationFrame(this.update), this.lastUpdate = new Date();
      }
    }, {
      key: "componentDidUpdate",
      value: function value() {
        function t(t) {
          void 0 === e.props.options ? e.options[t] = e.defaults[t] : e.options[t] !== e.props.options[t] && (void 0 === e.props.options[t] ? e.options[t] = e.defaults[t] : e.options[t] = e.props.options[t]);
        }

        var e = this;
        t("height"), t("amplitude"), t("speed"), t("points");
      }
    }, {
      key: "componentDidMount",
      value: function value() {
        this.frameId || this.resume();
      }
    }, {
      key: "componentWillUnmount",
      value: function value() {
        window.cancelAnimationFrame(this.frameId), this.frameId = 0;
      }
    }, {
      key: "render",
      value: function value() {
        var t = this.props,
            e = t.style,
            n = t.className,
            r = t.fill,
            o = (t.paused, t.options, t.children),
            i = t.id,
            a = (t.d, t.ref, l(t, ["style", "className", "fill", "paused", "options", "children", "id", "d", "ref"]));
        return s.default.createElement("div", {
          style: u({
            width: "100%",
            display: "inline-block"
          }, e),
          className: n,
          id: i,
          ref: this.container
        }, s.default.createElement("svg", {
          width: "100%",
          height: "100%",
          version: "1.1",
          xmlns: "http://www.w3.org/2000/svg"
        }, o, s.default.createElement("path", c({
          d: this.state.path,
          fill: r
        }, a))));
      }
    }]), r;
  }();

  return y.defaultProps = {
    paused: !1,
    fill: "#fff"
  }, y.propTypes = {
    paused: r.default.bool,
    fill: r.default.string,
    options: r.default.object
  }, y;
});